export function getUserInitials(name?: string | null, email?: string | null): string {
  const target = (name?.trim() || email?.split("@")[0]?.trim() || "").trim();
  if (!target) return "U";

  // Check multiple words (separated by space, underscore, dash, dot)
  const words = target.split(/[\s\-_\.]+/).filter(Boolean);
  if (words.length >= 2 && words[0] && words[1]) {
    const first = words[0][0] || "";
    const second = words[1][0] || "";
    return (first + second).toUpperCase();
  }

  // Check camelCase or PascalCase (e.g. "РезультатПро" -> "РП", "ResultPro" -> "RP")
  const upperMatches = target.match(/[A-ZА-ЯЁ]/g);
  if (upperMatches && upperMatches.length >= 2 && upperMatches[0] && upperMatches[1]) {
    return (upperMatches[0] + upperMatches[1]).toUpperCase();
  }

  // Single word: take first 1 or 2 characters
  return target.slice(0, Math.min(2, target.length)).toUpperCase();
}

const GRADIENT_PALETTES = [
  "from-indigo-600 to-cyan-500",
  "from-blue-600 to-teal-400",
  "from-violet-600 to-indigo-400",
  "from-purple-600 to-pink-500",
  "from-emerald-600 to-teal-500",
  "from-amber-500 to-orange-600",
];

export function getAvatarGradient(name?: string | null): string {
  if (!name) return GRADIENT_PALETTES[0]!;
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % GRADIENT_PALETTES.length;
  return GRADIENT_PALETTES[index]!;
}

export function getUserAvatarUrl(name?: string | null): string {
  const cleanName = encodeURIComponent(name?.trim() || "User");
  return `https://api.dicebear.com/7.x/initials/svg?seed=${cleanName}&chars=2`;
}
